import script from "./HcIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./HcIcon.vue?vue&type=script&setup=true&lang=ts"

import "./HcIcon.vue?vue&type=style&index=0&id=794dd8d4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4241219202/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-794dd8d4"]])

export default __exports__